import axios from "axios";
import { jwtDecode } from "jwt-decode";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import ViewerType1Dashboard from "./ViewerType1/ViewerType1Dashboard";
import ViewerType2Dashboard from "./ViewerType2/ViewerType2Dashboard";
import TelecallerDashboard from "./Telecaller/TelecallerDashboard";
import SalespersonDashboard from "./Salesperson/SalespersonDashboard";
import ProjectHeadDashboard from "./ProjectHead/ProjectHeadDashboard";
import UserSidebar from "./UserSidebar";
import PartnerDashboard from "./Partners/PartnerDashboard";
import { scheduleFollowUpReminder } from "../../utils/reminder";
import MarketerDashboard from "./Marketer/MarketerDashboard";
import { useOrganization } from "../../utils/OrganizationContext";
import ErrorModal from "../../utils/ErrorModal";

const Dashboard = () => {
  const { projectId } = useOutletContext();
  const [user, setUser] = useState(null);
  // const [role, setRole] = useState(null);
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [projects, setProjects] = useState();
  const orgId = JSON.parse(localStorage.getItem("org"));
    const { role } = useOrganization();
  // const [projectId, setProjectId] = useState(JSON.parse(localStorage.getItem("projectId")) || "");

  const [modalOpen, setModalOpen] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const afterClose = useRef(null);
  const showModal = (msg, onClose = null) => {
    setModalMsg(msg);
    afterClose.current = onClose;
    setModalOpen(true);
  };
  const handleModalClose = () => {
    setModalOpen(false);
    const next = afterClose.current;
    afterClose.current = null;
    if (next) next();
  };

  useEffect(() => {
    if (!storedUser?.accessToken) {
      navigate("/");
      return;
    }
    if (!orgId) return;
    // Decode JWT token
    // try {
    //   const decoded = jwtDecode(storedUser.accessToken);
    //   setRole(decoded.userRole[0]);
    // } catch (err) {
    //   console.error("Invalid token");
    //   navigate("/");
    //   return;
    // }
    const getOrgUser = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/org-user?username=${storedUser.username}&orgId=${orgId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
        );
        setUser(res.data);
      } catch (error) {
        showModal(error.response?.data?.Exception || "Access denied", () => {
          localStorage.clear();
          navigate("/");
        });
      }
    };
    getOrgUser();
  }, [orgId]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/project/team/all?orgId=${orgId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
        );
        setProjects(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchProjects();
  }, [orgId]);

  useEffect(() => {
    const fetchReminders = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/reminder?orgId=${orgId}`,
          {
            headers: {
              Authorization: `Bearer ${storedUser.accessToken}`,
            },
          },
        );

        const reminders = res.data || [];

        reminders.forEach((reminder) => {
          scheduleFollowUpReminder(reminder);
        });
      } catch (err) {
        console.error("Failed to initialize reminders", err);
      }
    };
    fetchReminders();
  }, [orgId]);

  return (
    <div
      style={{
        fontFamily: "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif",
        color: "#0F1B2A",
        minWidth: 0,
      }}
    >
      {role === "VT1" && <ViewerType1Dashboard projectId={projectId} />}
      {role === "VT2" && <ViewerType2Dashboard projectId={projectId} />}
      {role === "TELECALLER" && <TelecallerDashboard projectId={projectId} />}
      {role === "SALESPERSON" && <SalespersonDashboard projectId={projectId} />}
      {role === "PROJECT_HEAD" && (
        <ProjectHeadDashboard projectId={projectId} />
      )}
      {role === "PARTNER" && <PartnerDashboard projectId={projectId} />}
      {role === "MARKETER" && <MarketerDashboard projectId={projectId} />}

      <ErrorModal
        open={modalOpen}
        handleClose={handleModalClose}
        msg={modalMsg}
        type="error"
      />
    </div>
  );
};

export default Dashboard;